import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { SALES_SCRIPT_SECTIONS } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'
import {
  selectCommunicationBoardState,
  selectContactConfig,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import { isContentEmpty, withNewTabLinks } from '@/shared/tools/htmlHelper'
import { isSalesScriptAvailable } from './isSalesScriptAvailable'

type BoardSection = { section: string; content: string | null }

const SCRIPT_LABEL_KEYS: Record<string, string> = {
  [SALES_SCRIPT_SECTIONS.ENERGY]: 'subscriptionForm:sales_script_module.energy_button',
  [SALES_SCRIPT_SECTIONS.TELECOM]: 'subscriptionForm:sales_script_module.telecom_button',
}

const useSalesScript = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const authData = useSelector(selectAuthData)
  const { formIsLoaded } = useFormStatus()
  const { openSalesScriptSection: openSection } = useSelector(selectContactConfig)
  const { sections = [] } = useSelector(selectCommunicationBoardState)
  const hidden = !isSalesScriptAvailable(authData) || !formIsLoaded

  const content =
    (sections as BoardSection[]).find(({ section }) => section === openSection)?.content ?? ''

  const setOpenSection = (section: string | null) =>
    // @ts-ignore
    dispatch(updateClientData({ data: { openSalesScriptSection: section }, name: 'config' }))

  return {
    hidden,
    title: t('subscriptionForm:sales_script_module.module_title'),
    emptyText: t('subscriptionForm:sales_script_module.empty'),
    isOpen: Boolean(openSection),
    energyLabel: t(SCRIPT_LABEL_KEYS[SALES_SCRIPT_SECTIONS.ENERGY]),
    telecomLabel: t(SCRIPT_LABEL_KEYS[SALES_SCRIPT_SECTIONS.TELECOM]),
    modalTitle: openSection ? t(SCRIPT_LABEL_KEYS[openSection]) : '',
    content: withNewTabLinks(content),
    isEmpty: isContentEmpty(content),
    openEnergyScript: () => setOpenSection(SALES_SCRIPT_SECTIONS.ENERGY),
    openTelecomScript: () => setOpenSection(SALES_SCRIPT_SECTIONS.TELECOM),
    closeModal: () => setOpenSection(null),
  }
}

export default useSalesScript
